export default __webpack_public_path__ + "35dc4578986b4da83f51a4c8fa3841d3.svg";